import { ReactElement } from "react";
import { AgGrid, HelpIndicator, Flex } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Sizes } from "@jsq/ds/styles";
import { EntityType } from "../types";

export interface EntityCellRendererAgGridParams extends AgGrid.ICellRendererParams {
  value: string;
  data: EntityType;
}

export const EntityCellRenderer = (params: EntityCellRendererAgGridParams): ReactElement => {
  const entityValue = params.value;
  const showSpinner = params.data?.showSpinner;

  return (
    <Flex alignItems="center" gap={Sizes.SM}>
      <span>{entityValue}</span>
      {showSpinner && (
        <HelpIndicator
          id="entity-sync-tooltip"
          placement="top"
          content="Update in progress. The EUM calculation will be refreshed once the updates have been processed."
        >
          <Icon type="sync-alt" data-testid="icon-sync-alt" />
        </HelpIndicator>
      )}
    </Flex>
  );
};
